import { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router'
import './NotFound.scss'

interface NotFoundProps extends RouteComponentProps, WithTranslation {}

class NotFound extends Component<NotFoundProps> {
  componentDidMount() {
    setTimeout(() => {
      this.props.history.push('/')
    }, 5000)
  }

  render() {
    const { t } = this.props
    return (
      <div className="PageNotFoundComponent">
        <div className="flex">
          <img src="/errorEmoji.png" width="160" />
          <div>
            <h1>404</h1>
            <h2>{t('PAGE_NOT_FOUND')}</h2>
          </div>
        </div>
        <img src="/404.png" className="errorsImg" alt="Sorry, we can't find that page" />
      </div>
    )
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export default withTranslation('common')(NotFound)
